"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardWidgetText = void 0;

var _preact = require("preact");

var _ClampLines = _interopRequireDefault(require("@insided/shared/uikit/ClampLines"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var CardWidgetText = function CardWidgetText(_ref) {
  var content = _ref.content;
  return (0, _preact.h)("p", {
    className: "card-widget-text"
  }, (0, _preact.h)(_ClampLines.default, {
    id: "featured-topic-view",
    innerElement: "span",
    lines: 3,
    text: _htmlParser.default.stripHtml(content) || ''
  }));
};

exports.CardWidgetText = CardWidgetText;